import { render, staticRenderFns } from "./stock-adjustment-v2.vue?vue&type=template&id=2000c00a"
import script from "./stock-adjustment-v2.vue?vue&type=script&lang=js"
export * from "./stock-adjustment-v2.vue?vue&type=script&lang=js"
import style0 from "./stock-adjustment-v2.vue?vue&type=style&index=0&id=2000c00a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports